import { authenticatedFastApiAxiosInstanceAllowEmptyString } from "@/lib/data/http";
import { type APIResponse, type MatterSettlementCounter } from "@/lib/types";
import { baseFastApiMatterRoute } from "./matter";

const baseFastApiMatterSettlementCountersRoute = `${baseFastApiMatterRoute}/settlement-counters`;

type MatterSettlementCounterWritePayload = Omit<
  Partial<MatterSettlementCounter>,
  "attorneyFeeAmount" | "connections"
>;

const serializeMatterSettlementCounterWritePayload = (
  data: MatterSettlementCounterWritePayload,
) => {
  const payload = { ...data } as Partial<MatterSettlementCounter>;
  delete payload.attorneyFeeAmount;
  delete payload.connections;
  return payload;
};

export const createMatterSettlementCounterV1 = (
  data: MatterSettlementCounterWritePayload,
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .post<
      APIResponse<MatterSettlementCounter>
    >(baseFastApiMatterSettlementCountersRoute, serializeMatterSettlementCounterWritePayload(data))
    .then((res) => res.data);
};

export const deleteMatterSettlementCounterV1 = (
  data: Pick<MatterSettlementCounter, "id" | "matterId">,
) => {
  const { id } = data;

  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .delete<
      APIResponse<MatterSettlementCounter>
    >(`${baseFastApiMatterRoute}/settlement-counters/${id}`)
    .then((res) => res.data);
};

export const updateMatterSettlementCounterV1 = (
  data: Pick<MatterSettlementCounter, "id" | "matterId" | "dateModified"> &
    MatterSettlementCounterWritePayload,
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .patch<
      APIResponse<MatterSettlementCounter>
    >(baseFastApiMatterSettlementCountersRoute, serializeMatterSettlementCounterWritePayload(data))
    .then((res) => res.data);
};
